import React, { Component } from 'react';
import { Image } from '../../Image';

export const InlineImage = props => {
  //console.log('props:',props)
  return (
    <Image src={props.src.replace(/['"]+/g, '')} className={props.class.replace(/['"]+/g, '')} alt={props.alt.replace(/['"]+/g, '')}/>
  );
};
